import createLucideIcon from '../createLucideIcon';

/**
 * @component @name PanelTopBottomDashed
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMTZoMSIgLz4KICA8cGF0aCBkPSJNMTQgOGgxIiAvPgogIDxwYXRoIGQ9Ik0xOSAxNmgyIiAvPgogIDxwYXRoIGQ9Ik0xOSA4aDIiIC8+CiAgPHBhdGggZD0iTTMgMTZoMiIgLz4KICA8cGF0aCBkPSJNMyA4aDIiIC8+CiAgPHBhdGggZD0iTTkgMTZoMSIgLz4KICA8cGF0aCBkPSJNOSA4aDEiIC8+CiAgPHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgLz4KPC9zdmc+) - https://lucide.dev/icons/panel-top-bottom-dashed
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const PanelTopBottomDashed = createLucideIcon('panel-top-bottom-dashed', [
  ['path', { d: 'M14 16h1', key: '1cioin' }],
  ['path', { d: 'M14 8h1', key: '1lfen6' }],
  ['path', { d: 'M19 16h2', key: 'qbhnk2' }],
  ['path', { d: 'M19 8h2', key: '1jleli' }],
  ['path', { d: 'M3 16h2', key: '1r0mgj' }],
  ['path', { d: 'M3 8h2', key: '1ndivp' }],
  ['path', { d: 'M9 16h1', key: '1wweuk' }],
  ['path', { d: 'M9 8h1', key: 'zb2d67' }],
  ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', key: 'h1oib' }],
]);

export default PanelTopBottomDashed;
